export default "__VITE_ASSET__BYe5nTge__"